/**
 * Created by linda on 2019/1/16.
 */

import ReactGA from 'react-ga';

export const desktopHeaderClick = (label) => {
  ReactGA.event({
    category: '06. 選單使用狀況',
    action: 'Header',
    label: label,
  });
};

export const desktopFooterClick = (label) => {
  ReactGA.event({
    category: '06. 選單使用狀況',
    action: 'Footer',
    label: label,
  });
};

export const mobileMenuClick = (label) => {
  ReactGA.event({
    category: '06. 選單使用狀況',
    action: '選單',
    label: label,
  });
};
